/**
 * @generated SignedSource<<f7b322dc42572fc98d14e39765dd8959>>
 * @relayHash 9e3346230c503c46c2a78d537efee77c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c398c9897bd6b2ad55090a2587b099104efbe0df4f52d54fc62cbd659e13343

import type { ConcreteRequest, Query } from 'relay-runtime';
export type layoutManagerQuery$variables = {
  cloudId: string;
};
export type layoutManagerQuery$data = {
  readonly jira: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean | null | undefined;
      readonly leftSidebarWidth: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type layoutManagerQuery = {
  response: layoutManagerQuery$data;
  variables: layoutManagerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "leftSidebarWidth"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "layoutManagerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "layoutManagerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0c398c9897bd6b2ad55090a2587b099104efbe0df4f52d54fc62cbd659e13343",
    "metadata": {},
    "name": "layoutManagerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "43f1d006cf9c78cb66e90051d5dab554";

export default node;
